export async function printPdfUrl(url: string): Promise<void> {
  const target = url.trim();
  if (!target) throw new Error("PRINT_URL_REQUIRED");

  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  iframe.setAttribute("aria-hidden", "true");

  await new Promise<void>((resolve, reject) => {
    const timeout = window.setTimeout(() => reject(new Error("PRINT_LOAD_TIMEOUT")), 12_000);
    iframe.onload = () => {
      window.clearTimeout(timeout);
      resolve();
    };
    iframe.onerror = () => {
      window.clearTimeout(timeout);
      reject(new Error("PRINT_LOAD_FAILED"));
    };
    iframe.src = target;
    document.body.appendChild(iframe);
  });

  const win = iframe.contentWindow;
  if (!win) {
    iframe.remove();
    throw new Error("PRINT_WINDOW_UNAVAILABLE");
  }

  win.focus();
  win.print();
  window.setTimeout(() => iframe.remove(), 60_000);
}

export function printElementHtml(element: HTMLElement, title: string): void {
  printHtmlDocument(element.innerHTML, title);
}

export function printHtmlDocument(html: string, title: string): void {
  const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
    .map((node) => node.outerHTML)
    .join("\n");
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  iframe.setAttribute("aria-hidden", "true");
  document.body.appendChild(iframe);

  const win = iframe.contentWindow;
  const doc = iframe.contentDocument ?? win?.document;
  if (!win || !doc) {
    iframe.remove();
    throw new Error("PRINT_FRAME_UNAVAILABLE");
  }

  doc.open();
  doc.write(`<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>${escapeHtml(title)}</title>
  ${styles}
  <style>
    html, body { margin: 0; background: #fff !important; color: #0f172a; font-family: Arial, sans-serif; }
    body { padding: 0; }
    @page { size: A4; margin: 0; }
    @media print {
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      article { box-shadow: none !important; margin: 0 auto !important; }
    }
  </style>
</head>
<body>${html}</body>
</html>`);
  doc.close();
  window.setTimeout(() => {
    win.focus();
    win.print();
    window.setTimeout(() => iframe.remove(), 60_000);
  }, 250);
}

function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (char) => {
    const entities: Record<string, string> = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    };
    return entities[char] ?? char;
  });
}
